import React from 'react';
import "./Header.scss";
import { useHistory } from 'react-router-dom';

const Header = () => {
    const history = useHistory();
    return (
        <>
            <div className="header">
               
                <h3>Tu es étudiant et souhaite faire des études à l'étranger ? Viens chez StudentBank et ouvre ton compte bancaire
facilement et gratuitement. : Sois le premier a bénéficié la gratuité de nos services et d'un accompagnement
personnalisé dans toutes tes démarches administratives.
                </h3>
               
                <div className="buttoninscrit" onClick={()=>history.push("/inscription")}>OUVRIR UN COMPTE</div>

                
            </div>
        </>
    )
}

export default Header
